import { render } from "./UploadPrescription.vue?vue&type=template&id=1fd81110"
import script from "./UploadPrescription.vue?vue&type=script&lang=js"
export * from "./UploadPrescription.vue?vue&type=script&lang=js"

import "./UploadPrescription.vue?vue&type=style&index=0&id=1fd81110&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__